import {Component} from 'react'
import ScoreCard from '../ScoreCard'
import GameView from '../GameView'
import ResultView from '../ResultView'
import RulesPopup from '../RulesPopup'
import {
  AppContainer,
  BodyContainer,
  RulesButtonContainer,
} from './styledComponents'

const choicesList = [
  {
    id: 'ROCK',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/rock-image.png',
  },
  {
    id: 'SCISSORS',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/scissor-image.png',
  },
  {
    id: 'PAPER',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/paper-image.png',
  },
]

class RockPaperScissors extends Component {
  state = {
    score: 0,
    isGameInProgress: true,
    yourChoice: null,
    opponentChoice: null,
    result: '',
  }

  getResult = (yourId, opponentId) => {
    if (yourId === opponentId) return 'IT IS DRAW'
    if (
      (yourId === 'ROCK' && opponentId === 'SCISSORS') ||
      (yourId === 'PAPER' && opponentId === 'ROCK') ||
      (yourId === 'SCISSORS' && opponentId === 'PAPER')
    ) {
      return 'YOU WON'
    }
    return 'YOU LOSE'
  }

  onChoiceClick = id => {
    const {score} = this.state
    const opponent = choicesList[Math.floor(Math.random() * choicesList.length)]
    const resultValue = this.getResult(id, opponent.id)

    let updatedScore = score
    if (resultValue === 'YOU WON') updatedScore += 1
    else if (resultValue === 'YOU LOSE') updatedScore -= 1

    this.setState({
      yourChoice: choicesList.find(each => each.id === id),
      opponentChoice: opponent,
      result: resultValue,
      isGameInProgress: false,
      score: updatedScore,
    })
  }

  onPlayAgain = () => {
    this.setState({
      isGameInProgress: true,
      yourChoice: null,
      opponentChoice: null,
      result: '',
    })
  }

  render() {
    const {
      score,
      isGameInProgress,
      yourChoice,
      opponentChoice,
      result,
    } = this.state

    return (
      <AppContainer>
        <ScoreCard score={score} />
        <BodyContainer>
          {isGameInProgress ? (
            <GameView
              choicesList={choicesList}
              onChoiceClick={this.onChoiceClick}
            />
          ) : (
            <ResultView
              yourChoice={yourChoice}
              opponentChoice={opponentChoice}
              result={result}
              onPlayAgain={this.onPlayAgain}
            />
          )}
        </BodyContainer>
        <RulesButtonContainer>
          <RulesPopup />
        </RulesButtonContainer>
      </AppContainer>
    )
  }
}

export default RockPaperScissors
